<div class="profile-container">
    <div class="">
        <div class="profile-content">  
            <!-- <div class="personal-details">
                <h4 class="personal-details-title">Access Privileges Requests List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Folder/File Name</th>
                      <th scope="col">Folder/File Id</th>
                      <th scope="col">Requested By</th>
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let object of accessPrivilegesRequestsList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      }  ;let i = index">
                      <th scope="col">{{object.folderOrFileName}}</th>
                      <th scope="col">{{object.folderOrFileId}}</th>
                      <th scope="col">{{object.requestedBy}}</th>
                      <th scope="col">{{object.status}}</th>
                      <th scope="col">
                        <i class="bi bi-eye-fill" (click)="getAccessPrivilegesRequestByRequestId(object.requestId)" data-toggle="modal" data-target="#exampleModalView"></i>

                      </th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="accessPrivilegesRequestsList.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div> -->


            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                  </div>
                  <div class="add-block">
                      <div class="search">
                          <form autocomplete="off" >
                              <input type="text" placeholder="search">
                          </form>
                          <i class="bi bi-search" ></i>
                      </div>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 25%;">{{ 'client-docs-info.folderOrFileName' | translate }} </th>
                        <th style="width: 25%;">{{ 'client-docs-info.folderOrFileId' | translate }}</th>
                        <th style="width: 20%;">{{ 'client-docs-info.requestedBy' | translate }}</th>
                        <th style="width: 20%;">{{ 'client-docs-info.status' | translate }} </th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let object of accessPrivilegesRequestsList | paginate : {
                      itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 25%;">{{object.folderOrFileName}}</p>
                      <p style="width: 25%;">{{object.folderOrFileId}}</p>
                      <p style="width: 20%;">{{object.requestedBy}}</p>
                      <p style="width: 20%;">{{object.status}}</p>
                    
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getAccessPrivilegesRequestByRequestId(object.requestId)" data-toggle="modal" data-target="#exampleModalView"></i>
                      </p>
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && accessPrivilegesRequestsList.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'client-docs-info.accessPrivilegesRequest' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let list of singleAccessPrivilegesRequestData">
          <div class="row">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <label>{{ 'client-docs-info.requestedBy' | translate }}</label>
                <p>{{list.access.name}}</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <label>{{ 'client-docs-info.validFrom' | translate }}</label>
                <p>{{list.access.validFrom | date}}</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <label>{{ 'client-docs-info.validTo' | translate }} </label>
                <p>{{list.access.validTo | date}}</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <label>{{ 'client-docs-info.folderOrFileName' | translate }}</label>
                <p>{{list.folderOrFileName}}</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <label>{{ 'client-docs-info.status' | translate }}</label>
                <p>{{list.status}}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" *ngIf="list.status == 'PENDING'" (click)="updateAccessPrivilegesRequest('ACCEPTED')">{{ 'generic.apply' | translate }}</button>
            <button type="button" class="btn btn-danger" *ngIf="list.status == 'PENDING'" (click)="updateAccessPrivilegesRequest('REJECTED')">{{ 'generic.reject' | translate }}</button>
            <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>